import React, { useContext, useState } from 'react';
import { UserContext } from '../../contexts/user.context';
import { Box,  Container, Tab, Tabs } from '@mui/material';

import EditContent from './sections/content.component';
import Users from './sections/users.component';
import Report1 from './sections/report1.component';
import Report2 from './sections/report2.component';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

const DEFAULT_TAB_ITEM = 0;

const Admin: React.FC = () => {
    const { currentUser } = useContext(UserContext)
    const [tabItem, setTabItem] = useState<number>(DEFAULT_TAB_ITEM)

    const handleTabItemChange = (event: React.SyntheticEvent, tabValue: number) => {
        setTabItem(tabValue);
    }

    function TabPanel(props: TabPanelProps) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`full-width-tabpanel-${index}`}
                aria-labelledby={`full-width-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box sx={{ p: 3 }}>{children}</Box>
                )}
            </div>
        );
    }

    return (
        currentUser && currentUser.role === 'admin' ? (
            <Box
                component="main"
                sx={{
                    backgroundColor: (theme) =>
                        theme.palette.mode === 'light'
                            ? theme.palette.grey[100]
                            : theme.palette.grey[900],
                    flexGrow: 1,
                    minHeight: 'calc(100vh - 80px)',
                    padding: '70px 0',
                }}
            >
                <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
                    <Tabs
                        value={tabItem}
                        onChange={handleTabItemChange}
                        centered
                    >
                        <Tab value={0} label="Content" />
                        <Tab value={1} label="Users" />
                        <Tab value={2} label="Report 1" />
                        <Tab value={3} label="Report 2" />
                    </Tabs>

                    <TabPanel value={tabItem} index={0}>
                       <EditContent />
                    </TabPanel>
                    <TabPanel value={tabItem} index={1}>
                        <Users />
                    </TabPanel>
                    <TabPanel value={tabItem} index={2}>
                        <Report1 />
                    </TabPanel>
                    <TabPanel value={tabItem} index={3}>
                        <Report2 />
                    </TabPanel>
                                    
                </Container>
            </Box>
        ) : (
            <div style={{ padding: '100px 20px' }}>
                <h1>Admin Only</h1>
                <p>You must be an admin to view this page.</p>
            </div>
        )
    );
};

export default Admin;
